import { z } from 'zod';

// ---------------------------------------------------------------------------
// refresh-attachment-urls edge function contract.
//
// Discord CDN attachment URLs (cdn.discordapp.com / media.discordapp.net)
// are served behind a signed query string (?ex=&is=&hm=) that expires
// within ~24h. The bot deliberately stores the bare URL on feedback_pool
// (see normalise-discord-message.ts), which means anything that needs to
// actually fetch the asset must first ask Discord to mint a fresh signed
// URL via POST /attachments/refresh-urls. The portal hits this edge
// function on demand when a user clicks an attachment chip.
//
// Edge functions live in Deno and cannot import from this package today
// (the discord-oauth function duplicates its schemas for the same reason).
// We keep the canonical schemas here so the portal-side caller is type-
// checked against the same shape; if you change one side you must update
// the other.
// ---------------------------------------------------------------------------

export const RefreshAttachmentUrlsRequestSchema = z.object({
  // Bare Discord CDN URLs (no signature). The endpoint is bot-authenticated
  // server-side, so the caller never sees Discord credentials.
  urls: z.array(z.string().url()).min(1).max(50),
});
export type RefreshAttachmentUrlsRequest = z.infer<typeof RefreshAttachmentUrlsRequestSchema>;

export const RefreshAttachmentUrlsResponseSchema = z.object({
  // originalUrl -> refreshed signed URL. Any URL the caller does not own
  // (per RLS) is silently omitted; the portal renders that as a refresh
  // failure on click.
  refreshed: z.record(z.string(), z.string().url()),
});
export type RefreshAttachmentUrlsResponse = z.infer<typeof RefreshAttachmentUrlsResponseSchema>;
